import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { TrackingEvent } from 'webapp/enums/tracking';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class ClientPerformanceTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.CLIENT_PERFORMANCE;
	override trackEvent: TrackingEvent | '' = TrackingEvent.BUBBLE_CLIENT_PERFORMANCE_METRIC;

	get id(): string {
		return TourId.CLIENT_PERFORMANCE;
	}

	override get keyForPersistantDone(): string {
		return ClientPerformanceTour.keyForPersistantDone;
	}

	override get targetElement(): JQuery<HTMLElement> | null {
		return $('#mainFavorites a.empty').eq(0);
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.RIGHT,
				attachTo: () => {
					return this.targetElement;
				},
				sourceName: this.sourceName,
			},
		];
	}

	override start(): void {
		super.start();
		this.targetElement?.closest('.ct').addClass('emphasized');
	}

	override end(): void {
		super.end();
		this.targetElement?.closest('.ct').removeClass('emphasized');
	}
}
